var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/_core.js
// module id = 61
// module chunks = 0 1 2 3 6 7 8 10 11 12 13 14 16 17 19 21 22 23 25 26 27 28 29 31 32 33 34 35 36 37 38 40 41 43 44 45 46 47 48 49 51 52